import React from 'react';
import { Box } from '@material-ui/core';

import { Title } from '~/components/Title';
import TablePricesContractor from '~/pages/TablePricesContractor';

export default function Prestador() {
  return (
    <>
      <Title marginBottom={20}>Prestador</Title>

      <Box pt={1}>
        <TablePricesContractor embedded />
      </Box>
    </>
  );
}
